import React from "react";
import "./heading.css";
import { ReactComponent as SahabaDecore } from "../../../assets/sahaba-assets/headerDecore.svg";
function Heading({ title, subtitle }) {
    return (
        <div className="flex relative  w-full  h-fit">
            <div className="smooth text-moonBlue-600 dark:text-moonBlue-300 smooth font-lama flex-col space-y-5 flex-center-both  px-5 py-5">
                <h1 className="text-4xl font-w-bold font-voxo italic sm:text-5xl">{title} </h1>
            </div>
            <SahabaDecore className="-mr-24" />
        </div>
    );
}

export default Heading;
